export const namespace = 'windows'
